"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FieldLabel = void 0;

var _react = _interopRequireDefault(require("react"));

var _types = require("../types");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var FieldElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.FieldElementDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("field", _flowRuntime["default"].ref(FieldElementDefinition)), _flowRuntime["default"].property("isRequired", _flowRuntime["default"]["boolean"](), true)));

var FieldLabel = function FieldLabel(_arg) {
  var field = _arg.field,
      isRequired = _arg.isRequired;
  return field.label ? /*#__PURE__*/_react["default"].createElement("div", {
    className: field.ui && field.ui.labelPosition === 'left' ? 'col span_3_of_12 label' : 'label'
  }, field.label, !isRequired && /*#__PURE__*/_react["default"].createElement("span", null, " (optional)")) : null;
};

exports.FieldLabel = FieldLabel;
FieldLabel.defaultProps = {
  isRequired: undefined
};
var _default = FieldLabel;
exports["default"] = _default;